export default "__VITE_ASSET__B6$lhr9B__"